export enum SearchType {
  BOTH = 'BOTH',
  RECORDINGS = 'RECORDINGS',
  ANNOTATIONS = 'ANNOTATIONS',
}
